export const SETTINGS_COPY = {
  title: '設定',
  loading: '載入設定…',
  loadingChannels: '載入粉專…',
  display: '顯示',
  displayHint: '只影響這部裝置，換一部機要再設定一次。',
  adminOnly: '以下設定只有管理員看得到。',
  editable: '公司設定',
  name: '公司名稱',
  suggestionMode: '建議模式',
  suggestionModes: { auto: '自動產生建議', manual: '由人員按需產生' },
  suggestionModeHints: {
    auto: '新項目一進來就先草擬，快一點，但會用多一些 token。',
    manual: '同事按下「產生建議」才會產生。',
  },
  primaryProvider: '主要 AI provider',
  secondaryProvider: '備援 AI provider（主要 provider 出錯時接手分類和建議）',
  secondaryNone: '不使用備援',
  claimIdleMinutes: '認領閒置分鐘數',
  claimIdleHint: '超過這段時間沒有動作，認領會自動釋放。',
  replyClaim: '回覆前要不要先認領',
  replyClaimModes: { required: '要先認領才可以回覆', optional: '發送時自動認領' },
  replyClaimHints: {
    required: '同事要先按「認領」，回覆框才會打開，其他人也看得到誰在處理哪個項目。',
    optional:
      '不用先按「認領」也可以直接回覆，發送時系統會自動替你認領。如果同事已經認領了這個項目，你的回覆不會送出。想先佔住一個項目慢慢寫，仍然可以按「認領」。',
  },
  answerabilityThreshold: '可答性門檻',
  answerabilityHint: '檢索相似度低於這個門檻時，不會產生建議，改為顯示「沒有把握的建議」。',
  save: '儲存設定',
  saving: '儲存中…',
  saved: '設定已儲存',
  operator: '合約條款（由平台營運方設定）',
  operatorHint: '這些是服務合約的一部分，需要調整請聯絡 Red Digital。',
  retentionDays: '保存期限（日）',
  llmConcurrency: 'LLM 並發上限',
  channels: '已連接的粉專',
  connected: '已連接',
  disconnected: '已斷線',
  webhookMissing: 'Webhook 未訂閱',
  webhookMissingHint: '新訊息不會進來，請重新連接這個粉專。',
  healthBannerTitle: '粉專連線異常',
  healthBannerDisconnected: (names: readonly string[]) => `${names.join('、')} 已斷線。`,
  healthBannerUnsubscribed: (names: readonly string[]) => `${names.join('、')} Webhook 未訂閱，新訊息不會進來。`,
  healthBannerAction: {
    admin: '請到「設定」重新連接。',
    member: '請通知管理員到「設定」重新連接。',
  },
  reconnect: '重新連接',
  reconnecting: '連接中…',
  lastChecked: (value: string) => `最後檢查 ${value}`,
  neverChecked: '尚未檢查',
  members: '成員',
  loadingMembers: '載入成員…',
  membersHint: '更改角色、重設密碼或移除成員後，對方所有裝置都會被登出。',
  membersEmpty: '這間公司暫時沒有成員',
  cancel: '取消',
  you: '你',
  inviteTitle: '邀請成員',
  inviteHint: '設定一個初始密碼交給對方。對方用這個 email 和密碼登入後，必須先改成自己的密碼。',
  inviteEmail: 'Email',
  inviteName: '顯示名稱（可選）',
  inviteRole: '角色',
  inviteSubmit: '發出邀請',
  inviting: '邀請中…',
  inviteEmailInvalid: '請輸入有效的 email 地址',
  invited: (email: string) => `已加入 ${email}。`,
  roleHints: {
    reviewer: '處理收件匣、回覆客人。',
    approver: '另外可以接手同事的項目、審核回覆範本。',
    admin: '另外可以管理設定、粉專和成員。',
  },
  roleAbilities: {
    reviewer: '處理收件匣和回覆客人',
    approver: '接手同事的項目和審核回覆範本',
    admin: '管理設定、粉專和成員',
  },
  changeRole: '更改角色',
  changeRoleTitle: '更改角色',
  changeRoleLegend: (name: string) => `${name} 的角色`,
  changeRoleConfirm: '確認更改',
  demoteConfirm: '確認降級',
  changingRole: '更改中…',
  roleChanged: (name: string, role: string) => `已把 ${name} 改為${role}。`,
  demoteBody: (name: string, from: string, to: string, lost: readonly string[]) =>
    `${name} 會由「${from}」改為「${to}」，即時失去以下權限：${lost.join('、')}。`,
  selfDemoteNote: '這是你自己的帳號。確認後你會即時失去這些權限，要改回需要另一位管理員幫你。',
  lastAdmin: '唯一的管理員',
  lastAdminHint: '工作區至少要有一位管理員。要移除或降級這位成員，請先把另一位成員設為管理員。',
  remove: '移除成員',
  removing: '移除中…',
  removeTitle: '移除成員',
  removeBody: (email: string, workspace: string) =>
    `確定要把 ${email} 從「${workspace}」移除嗎？對方會即時失去這個工作區的存取權；之前處理過的項目和回覆紀錄會保留。之後要加回，需要重新邀請。`,
  removeSelfNote: '這是你自己的帳號。移除後你會即時失去這個工作區的存取權，要回來需要另一位管理員重新邀請你。',
  confirmRemove: '確認移除',
  removed: (email: string) => `已移除 ${email}。`,
  connectTitle: '連接新粉專',
  connectHint: '會轉到 Meta 的授權頁面。在那裡選好要連接的專頁，完成後回到這一頁就會看到它。',
  instagramHint: 'Instagram 需要是商業或創作者帳號，並已連結到一個 Facebook 專頁。',
  connectFacebook: '連接 Facebook 專頁',
  connectInstagram: '連接 Instagram 帳號',
  connecting: '前往授權…',
  channelsEmpty: '尚未連接任何粉專',
  channelsEmptyBody: '連接後，粉專的新留言和私訊就會進入收件匣。',
  disconnect: '中斷連接',
  disconnecting: '中斷中…',
  disconnectTitle: '中斷連接粉專',
  disconnectBody: (name: string, platform: string) =>
    `確定要中斷「${name}」（${platform}）嗎？中斷後，這個粉專的新留言和私訊會即時停止進入收件匣，收件匣裡來自這個粉專的項目也無法再從這裡回覆。`,
  disconnectAfter: '之後要恢復，需要重新連接並在 Meta 重新授權。',
  confirmDisconnect: '確認中斷',
  disconnectDone: (name: string) => `已中斷「${name}」，這個粉專不會再有新訊息進來。`,
  forbidden: '你沒有權限修改設定',
  forbiddenBody: '請聯絡公司的管理員。',
} as const

export const META_APP_COPY = {
  title: 'Meta 應用程式',
  loading: '載入 Meta 應用程式設定…',
  missing: '必須先設定你自己的 Meta 應用程式，才能連接粉專。',
  appId: 'App ID',
  appSecret: 'App Secret',
  appSecretHint: '在 Meta 開發者後台「應用程式設定 → 基本資料」可以找到。儲存後不會再顯示。',
  save: '儲存',
  saving: '儲存中…',
  secretSetAt: (date: string) => `App Secret 已設定（${date}）`,
  replaceSecret: '更換 App Secret',
  replaceApp: '更換應用程式',
  cancel: '取消',
  copy: '複製',
  copied: '已複製',
  copyFailed: '未能複製，請手動選取內容。',
  webhookUrl: 'Webhook 回呼網址',
  webhookUrlHint: '貼到 Meta 應用程式的「Webhooks」設定。',
  verifyToken: '驗證 token',
  verifyTokenHint: '和 Webhook 回呼網址一起貼。',
  verifyTokenReissued: '這次儲存重新產生了驗證 token，請把上面的新 token 重新貼到 Meta 應用程式的 Webhooks 設定，否則 Meta 會驗證失敗。',
  oauthRedirectUri: 'OAuth 回呼網址',
  oauthRedirectUriHint: '貼到「Facebook 登入 → 設定」的「有效的 OAuth 重新導向 URI」。',
  confirmTitle: '更換應用程式',
  confirm: '確認更換',
} as const
